// Lets the demo tour flip the DemoWatchView's Monitor/Inspect tab between steps.
// DemoWatchView registers its setter on mount; tour steps call it via `before`.
export const demoTabBridge: {
  setTab: ((tab: 'monitor' | 'inspect') => void) | null;
} = { setTab: null };
